export default window => /bot|google|phantom|crawler|spider|crawling|headless|^mozilla\/4\.0$/i.test(window.navigator.userAgent)


// WEBPACK FOOTER //
// ./node_modules/santa-main-r/src/lib/common/isBot.js